export default {
  familyName: 'Sora',
  fullName: 'Sora Bold',
  postscriptName: 'Sora-Bold',
  category: 'sans-serif',
  capHeight: 730,
  ascent: 970,
  descent: -290,
  lineGap: 0,
  unitsPerEm: 1000,
  xHeight: 534,
  xWidthAvg: 517,
  subsets: {
    latin: {
      xWidthAvg: 517
    },
    thai: {
      xWidthAvg: 867
    }
  }
};
